// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Domain Prices',
  subtitle: 'Manage domain extension prices',
  addNew: 'Add New Price',
  edit: 'Edit',
  extension: 'Extension',
  purchasePrice: 'Purchase Price',
  salePrice: 'Sale Price',
  currency: 'Currency',
  status: 'Status',
  actions: 'Actions',
  noPrices: 'No prices defined yet',
  noPricesDesc: 'Start by adding your first price.',
  priceAdded: 'Price successfully added',
  priceUpdated: 'Price successfully updated',
  priceDeleted: 'Price successfully deleted',
  fetchError: 'Prices could not be retrieved',
  addError: 'Price could not be added',
  updateError: 'Price could not be updated',
  deleteError: 'Price could not be deleted',
  confirmDelete: 'Are you sure you want to delete this price?',
  profit: 'Profit',
  listTitle: 'Domain Price List',
  addTitle: 'Add New Domain Price',
  editTitle: 'Edit Domain Price',
  extensionPlaceholder: 'Ex: .com, .com.tr, .av.tr',
  extensionHint: 'Extension starting with dot (ex: .com)',
  addPrice: 'Add Price',
  update: 'Update',
  infoText: 'Define prices by domain extension. For example: .com, .com.tr, .av.tr, .org.tr, etc. These prices will be automatically retrieved when adding a domain to invoices.',
  gold: 'Gold'
};
